import { PiSpeakerSimpleHigh, PiSpeakerSimpleLow, PiSpeakerSimpleX } from 'react-icons/pi'

interface VolumeButtonProps {
  mute: boolean
  volume: number
}

const VolumeButton: React.FC<VolumeButtonProps> = ({ mute, volume }) => {
  if (mute || volume === 0) {
    return (
      <span data-testid="volume-icon" data-variant="muted">
        <PiSpeakerSimpleX className="h-4 w-4 md:h-5 md:w-5" />
      </span>
    )
  }

  if (volume < 0.5) {
    return (
      <span data-testid="volume-icon" data-variant="low">
        <PiSpeakerSimpleLow className="h-4 w-4 md:h-5 md:w-5" />
      </span>
    )
  }

  return (
    <span data-testid="volume-icon" data-variant="high">
      <PiSpeakerSimpleHigh className="h-4 w-4 md:h-5 md:w-5" />
    </span>
  )
}

export default VolumeButton
